<template>
	<div id="editor">
		<div v-if="working" class="d-flex justify-content-center align-items-center" style="min-height:300px">
			<spinner size="huge" message="Updating..."></spinner>
		</div>
		<div v-if="!working">
			<form v-on:submit.prevent="transmitForm">
				<div class="container">
					<div class="head row">
						<div class="col col-sm-3" style="text-align:left">
							<i class="pseudobutton mdi mdi-arrow-right-bold-circle mdi-24px" @click="$emit('closeEditor')"><span style="">Back</span></i>
						</div>
						<div class="col col-sm-9">
							<h3>Edit Site #<i>{{site.S_ID}}</i></h3>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_name">Name</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_name" v-model="site.S_NAME" id="s_name"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_name">Link Name</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_name" v-model="site.S_LINKNAME" id="s_name"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_name">Link URL</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_name" v-model="site.S_LINKURL" id="s_name"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-12 col-form-label" for="wp_password">Text</label>
						<div class="col-sm-12">
							<textarea class="form-control form-control-sm" style="height:150px" v-model="site.S_OTHER" name="S_OTHER" id="S_OTHER"></textarea>
						</div>
					</div>
					<div class="row">
						<div class="col form-group" style="text-align:center">
							<button class="btn btn-success" type="submit">Change</button>
						</div>
						<div class="col form-group" style="text-align:center">
							<button class="btn btn-danger" type="button" @click="assertDelete">Delete</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import Spinner from 'vue-simple-spinner'

export default {

	components: {
		Spinner
	},
	props: ['site', 'servers', 'working', 'registries'],

	data() {
		return {
			renewclass: ''
		}
	},
	created: function() {
	},
	methods: {
		assertDelete() {
			if(confirm("Are you sure you want to remove this Service?")) {
				this.$emit('deleteItem', this.site.S_ID)
			}
		},
		transmitForm() {
			var fields = [ 'S_ID', 'S_NAME', 'S_LINKNAME', 'S_LINKURL', 'S_OTHER']
			let transfer = {}
			for(var i = 0;i < fields.length;i++) {
				transfer[fields[i]] = this.site[fields[i]]
			}
			this.$emit('updateItem', transfer)
		},
  }
}
</script>
